import React from "react";
import "./loaderpojas.css";
import loaderImg from "../img/loaderpojas.png";

export default function LoaderPojas() {
  return (
    <div className="loader-pojas-overlay">
      <div className="loader-pojas-inner">

        <div className="loader-pojas-wrap">
          <img
            src={loaderImg}
            alt="Učitavanje..."
            className="loader-pojas-img loader-pojas-gray"
          />
          <img
            src={loaderImg}
            alt=""
            className="loader-pojas-img loader-pojas-color"
          />
        </div>

        <div className="loader-bar-track">
          <div className="loader-bar-fill" />
        </div>

        <p className="loader-pojas-label">Učitavam pojaseve...</p>

      </div>
    </div>
  );
}